export default "__VITE_ASSET__biQgaArB__"